import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BuyerRoutingModule } from './buyer-routing.module';
import { AddNewProjectComponent } from './add-new-project/add-new-project.component';
import { BuyerApiService } from './service/buyer-api.service';
import { ChatTestComponent } from './chat-test/chat-test.component';

@NgModule({
  imports: [
    CommonModule,
    BuyerRoutingModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [AddNewProjectComponent, ChatTestComponent],
  providers: [BuyerApiService]
})
export class BuyerModule { }



// WEBPACK FOOTER //
// ./src/app/buyer/buyer.module.ts